import { createFileRoute } from '@tanstack/react-router';

import { NotificationChannels } from '#modules/user/features/profile/components/Settings/NotificationChannels';

export const Route = createFileRoute(
  '/{-$locale}/_layout/_dashboard/_authed/dashboard/settings/_settings/notifications'
)({
  component: NotificationChannels,
  ssr: false,
});
